<form [formGroup]="formGroup">
	<div class="row">
		<bcb-component-wrapper
			[componentClassList]="componentClassList"
			[remainingPercentage]="onShareholderChange()"
			[currentStep]="currentStep"
			[entity]="data.entity"
			[formGroup]="formGroup"
			[questions]="questionsConfig.questions.value"
			[questionsConfig]="questionsConfig"
			[visibleControls]="visibleControls"
		></bcb-component-wrapper>
	</div>
</form>
